import { z } from "zod";

import { dashboardWidgetLinks } from "../_dashboard-widget-link";

import { legend, thresholds, yAxis } from "./_sub-schemas";
import { timeSeriesQueries } from "./_time-series-query";

export const barChartSchema = z
	.object({
		plugin: z.object({
			kind: z.literal("BarChart"),
			spec: z.object({ yAxis, legend, thresholds }).catch({}),
		}),

		queries: timeSeriesQueries,

		links: dashboardWidgetLinks,
	})
	.transform(({ plugin, queries, links }) => ({ ...plugin, queries, links }));

export type BarChart = z.infer<typeof barChartSchema>;
